module.exports = __webpack_public_path__ + "static/react-a1766471e07bbdf2d665e2f49caa5ebd.png";